import React from "react";
import PreFormulServicesRedesign from "../redesign/PreFormulServicesRedesign";

const PreFormulServices = () => {
  return <PreFormulServicesRedesign />;
};

export default PreFormulServices;
